module.exports = __webpack_public_path__ + "img/4.a7e33f8c.jpg";